<template>
    <div class="tile is-ancestor">
        <div style="min-height: 500px;" class="tile is-parent">
            <article 
            :style="`background: linear-gradient( to top, rgba(22, 22, 22, 0.6), rgba(22, 22, 22, 0.6)),  url(${entries[0].thumbnail}); background-position: center; background-repeat: no-repeat; background-attachment:scroll;background-size:cover;`"
            class="tile is-child notification has-text-white">
                <p class="subtitle">{{ new Date(entries[0].timestamp).toLocaleDateString() }}</p>
                <p class="title">{{entries[0].title}}</p>
                <div class="content">
                    <p>{{entries[0].description}}</p>
                    <a :href="entries[0].getPublicDetail">Leer mas</a>
                </div>
            </article>
        </div>

        <div style="min-height: 500px;" class="tile is-vertical is-5">
            <div class="tile">
                <div class="tile is-parent is-vertical">

                    <article 
                    :style="
                    `background: linear-gradient( to top, rgba(22, 22, 22, 0.6), rgba(22, 22, 22, 0.6)),  url(${entries[1].thumbnail}); background-position: center; background-repeat: no-repeat; background-attachment:scroll;background-size:cover;`"
                    class="tile is-child notification has-text-white">
                        <p class="subtitle">{{ new Date(entries[1].timestamp).toLocaleDateString() }}</p>
                        <p class="title is-size-3">{{entries[1].title}}</p>
                        <div class="content">
                            <p v-if="entries[1].description">{{entries[1].description.substr(0, 50)}}... <a :href="entries[1].getPublicDetail">Leer mas</a></p>
                            <div v-else>
                                <a :href="entries[1].getPublicDetail">Leer mas</a>
                            </div>
                        </div>
                    </article>

                    <article
                    :style="`background: linear-gradient( to top, rgba(22, 22, 22, 0.6), rgba(22, 22, 22, 0.6)),  url(${entries[2].thumbnail}); background-position: center; background-repeat: no-repeat; background-attachment:scroll;background-size:cover;`"
                    class="tile is-child notification has-text-white">
                        <p class="subtitle">{{ new Date(entries[2].timestamp).toLocaleDateString() }}</p>
                        <p class="title">{{entries[2].title}}</p>
                        <div class="content">
                            <p v-if="entries[2].description">{{entries[2].description.substr(0, 50)}}... <a :href="entries[2].getPublicDetail">Leer mas</a></p>
                            <div v-else>
                                <a :href="entries[2].getPublicDetail">Leer mas</a>
                            </div>
                        </div>
                    </article>
                    
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props:{
        entries:{
            type:Array,
            default: new Array([])
        }
    },

}
</script>